<div class="fee">
  <form [formGroup]="form">
    <div class="fee_row main_row">
      <div class="col-50">
        <div class="fee_row">
          <div class="col-50 field-wrapper-mr">
            <mat-form-field class="name-field">
              <input
                matInput
                placeholder="Name:"
                i18n-placeholder
                matTooltip="Enter fee name"
                i18n-matTooltip
                matTooltipPosition="above"
                matTooltipClass="text-center"
                formControlName="name"
                [matAutocomplete]="auto"
                type="text"
                required
              />
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option
                  *ngFor="let category of feeCategories"
                  [value]="category"
                  [matTooltip]="category"
                  matTooltipClass="text-center"
                  matTooltipPosition="right"
                  class="category-option"
                  >{{ category }}</mat-option
                >
              </mat-autocomplete>
              <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')" i18n>
                Name is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-50 field-wrapper-ml field-wrapper-mr">
            <mat-form-field>
              <input
                matInput
                matTooltip="Enter fee amount"
                i18n-matTooltip
                matTooltipPosition="above"
                matTooltipClass="text-center"
                [placeholder]="form.get('type').value === 'pct' ? 'Amount (%)' : 'Amount (' + currencyCode + ')'"
                formControlName="amount"
                type="number"
                required
              />
              <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('required')" i18n>
                Amount is required
              </mat-error>
              <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('min')" i18n>
                Amount must be at least 1
              </mat-error>
              <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('max')" i18n>
                Amount must be at most 100
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="fee_row">
          <div class="col-50 field-wrapper-mr">
            <mat-form-field>
              <mat-select
                matTooltip="Enter the type of fee"
                i18n-matTooltip
                matTooltipPosition="above"
                matTooltipClass="text-center"
                placeholder="Type"
                i18n-placeholder
                formControlName="type"
                required
              >
                <mat-option value="pct" i18n>Percent</mat-option>
                <mat-option value="flat" i18n>Flat</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('type').touched && form.get('type').hasError('required')" i18n>
                Type is required
              </mat-error>
            </mat-form-field>
            <mat-slide-toggle formControlName="status">{{
              form.get('status').value ? 'Active' : 'Inactive'
            }}</mat-slide-toggle>
            <mat-checkbox
              matTooltip="This indicates if the fee is charged upfront"
              i18n-matTooltip
              matTooltipPosition="above"
              matTooltipClass="text-center"
              formControlName="upfront"
              class="upfront-control"
              i18n
              >Upfront</mat-checkbox
            >
          </div>
          <div class="col-50 field-wrapper-ml field-wrapper-mr">
            <mat-form-field>
              <mat-select
                matTooltip="Select the modality. This determines how the fee is applied to the booking"
                i18n-matTooltip
                matTooltipPosition="above"
                matTooltipClass="text-center"
                placeholder="Modality"
                i18n-placeholder
                formControlName="modality"
                required
              >
                <mat-option value="ps" i18n>Per Stay</mat-option>
                <mat-option value="pn" i18n>Per Night</mat-option>
                <mat-option value="pp" i18n>Per Person</mat-option>
                <mat-option value="pppn" i18n>Per Person/Per Night (PP/PN)</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('modality').touched && form.get('modality').hasError('required')" i18n>
                Modality is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-50 field-wrapper-ml">
        <mat-form-field class="mat-block">
          <textarea
            matInput
            maxlength="500"
            rows="6"
            formControlName="description"
            placeholder="Description"
            i18n-placeholder
            class="description-textarea"
          ></textarea>
        </mat-form-field>
      </div>
    </div>

    <i
      matTooltip="Remove Fee"
      i18n-matTooltip
      matTooltipClass="text-center"
      matTooltipPosition="above"
      (click)="remove.emit(true)"
      class="fal fa-trash-alt"
    ></i>

    <div class="show-more">
      <a *ngIf="!showDetails" (click)="showDetails = true" href="javascript:;">
        <i class="fal fa-chevron-down"></i> <ng-container i18n>More Options</ng-container>
      </a>
      <a *ngIf="showDetails" (click)="showDetails = false" href="javascript:;">
        <i class="fal fa-chevron-up"></i> <ng-container i18n>Less Options</ng-container>
      </a>
      <mat-error *ngIf="!showDetails && form.get('end').touched && form.get('end').invalid && endDateInPast()" i18n>
        Scheduling End date shouldn't be in the past
      </mat-error>
      <mat-error
        *ngIf="
          !showDetails &&
          ((startCtrl.touched && startCtrl.hasError('required')) || (endCtrl.touched && endCtrl.hasError('required')))
        "
        i18n
      >
        Both scheduling start and end dates are required
      </mat-error>
    </div>

    <div [class.hidden]="!showDetails">
      <div class="form_row">
        <mat-form-field>
          <input
            matTooltip="This indicates if the fee applies over or under the set guest count. Use positive values to indicate over and negative to indicate under"
            i18n-matTooltip
            matTooltipPosition="above"
            matTooltipClass="text-center"
            matInput
            placeholder="Guest Threshold"
            i18n-placeholder
            formControlName="guest_threshold"
            type="number"
          />
        </mat-form-field>

        <mat-form-field>
          <input
            matTooltip="This indicates if the fee applies over or under a specific length. Use positive values to indicate over and negative to indicate under"
            i18n-matTooltip
            matTooltipPosition="above"
            matTooltipClass="text-center"
            matInput
            placeholder="Length Threshold"
            i18n-placeholder
            formControlName="length_threshold"
            type="number"
          />
        </mat-form-field>

        <mat-form-field class="mat-calendar">
          <input
            matInput
            [matDatepicker]="startPicker"
            [max]="maxStartDate.value"
            placeholder="Scheduling Start"
            i18n-placeholder
            matTooltip="Set the start date. This determines on which dates the fee is applied"
            i18n-matTooltip
            matTooltipPosition="above"
            matTooltipClass="text-center"
            (focus)="startPicker.open()"
            formControlName="start"
            tabindex="6"
            [required]="!!endCtrl.value"
          />
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
          <mat-error *ngIf="form.get('start').touched && form.get('start').hasError('required')" i18n>
            Scheduling Start date is required
          </mat-error>
        </mat-form-field>

        <mat-form-field class="mat-calendar">
          <input
            matInput
            [matDatepicker]="endPicker"
            [min]="minEndDate.value"
            placeholder="Scheduling End"
            i18n-placeholder
            matTooltip="Set the end date. This determines on which dates the fee is applied"
            i18n-matTooltip
            matTooltipPosition="above"
            matTooltipClass="text-center"
            (focus)="endPicker.open()"
            formControlName="end"
            [required]="!!startCtrl.value"
            tabindex="6"
          />
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
          <mat-error *ngIf="form.get('end').touched && form.get('end').invalid && endDateInPast()" i18n>
            Scheduling End date shouldn't be in the past
          </mat-error>
          <mat-error *ngIf="form.get('end').touched && form.get('end').hasError('required')" i18n>
            Scheduling End date is required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form_row">
        <app-select-search
          bindLabel="friendlyName"
          bindValue="id"
          floatLabel="never"
          [multiple]="false"
          [items]="channels$ | async"
          [ctrl]="form.get('channel_id')"
          placeholder="Channel"
          i18n-placeholder
        ></app-select-search>

        <mat-form-field>
          <mat-select
            matTooltip="This determines on which days the fee is applied"
            i18n-matTooltip
            matTooltipPosition="above"
            matTooltipClass="text-center"
            placeholder="Day of Week"
            i18n-placeholder
            formControlName="dow"
            multiple
          >
            <mat-option value="1" i18n>Monday</mat-option>
            <mat-option value="2" i18n>Tuesday</mat-option>
            <mat-option value="3" i18n>Wednesday</mat-option>
            <mat-option value="4" i18n>Thursday</mat-option>
            <mat-option value="5" i18n>Friday</mat-option>
            <mat-option value="6" i18n>Saturday</mat-option>
            <mat-option value="7" i18n>Sunday</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-checkbox
          matTooltip="This indicates if the fee is refundable"
          i18n-matTooltip
          matTooltipPosition="above"
          matTooltipClass="text-center"
          formControlName="refundable"
          i18n
          >Refundable</mat-checkbox
        >

        <mat-checkbox
          matTooltip="This indicates if the fee is taxable"
          i18n-matTooltip
          matTooltipPosition="above"
          matTooltipClass="text-center"
          formControlName="taxable"
          i18n
          >Taxable</mat-checkbox
        >
      </div>
    </div>
  </form>
</div>
